define([
    'text!fnjinews2021/component/swiper-time.html',
    // 'common/api',
    'jquery',
    '../../../../vendor/swiper/swiper-bundle.min.js',

    'css!vendor/swiper/swiper-bundle.min.css',
    'css!fnjinews2021/component/swiper-time.css'

], function(
    tpl,
    // Api,
    $,
    Swiper
){
    return {
        template: tpl,
        data: function(){
            return {
                isPC: true,
                year: [],
                yearNum: 0,
                mySwiper: {},
                slideTimeWidth: 0,
                // slideTimeTitle: 176
                slideTimeTitle: 86,
                slideTimeTitlePhone: 102,
                page: 0
            };
        },
        // 这里是传入的数据
        props: {
            SlickImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            dotsShow: {
                type: Number
            },
            SwiperImage: {
                type: Array,
                default: function () {
                    return []
                }
            },
            SwiperType: String
        },
        methods: {
            pcIs: function(){
                var obj = this;
                if($(window).width()<=750){
                    obj.isPC = false;
                }else {
                    obj.isPC = true;
                }
            },
            init: function () {
                var obj = this;
                if(this.SwiperType=='time'){
                    setTimeout(function () {
                        obj.mySwiper = new Swiper('#swiper-time', {
                            // slidesPerView: 3,
                            slidesPerView: 'auto',
                            freeMode: true,
                            lazyLoading : true,
                            freeModeMomentum : false,
                            on: {
                                slideChangeTransitionEnd: function () {
                                    obj.page = this.activeIndex;
                                }
                            }
                        });
                        // console.log(obj.mySwiper);
                        obj.slideTimeWidth = $('.swiper-slide').width();
                    },500);
                }
            },
            toPage: function(index){
                var obj = this;
                if(index==1){
                    if(parseInt(obj.page)<obj.SwiperImage.length){
                        obj.page+=1;
                    }
                }else {
                    if(parseInt(obj.page)>0){
                        obj.page-=1;
                    }
                }
                obj.mySwiper.slideTo(obj.page);
            }
        },
        watch: {
            SwiperImage: function () {
                var obj = this;
                var year = '';
                if(obj.SwiperImage.length){
                    for(var i=0;i<obj.SwiperImage.length;i++){
                        if(i===0){
                            year = obj.SwiperImage[i].year;
                            obj.year.push({name:obj.SwiperImage[i].year,value: 1,place: 0});
                        }else {
                            if(obj.SwiperImage[i].year==year){
                                obj.SwiperImage[i].year = '';
                                obj.year[obj.year.length-1].value += 1;
                                obj.year[obj.year.length-1].place += 1;
                            }else {
                                year = obj.SwiperImage[i].year;
                                obj.year.push({name:obj.SwiperImage[i].year,value: 1,place: obj.year[obj.year.length-1].place+1});
                            }
                        }
                        // obj.year.push(obj.SwiperImage[i].year);
                    }
                }
                obj.init();
            },
            'mySwiper.translate': function () {
                var obj = this;
                var theNum = 0;
                var nextNum = 0;
                var toNum = 0;
                obj.yearNum = 0;
                if(Math.abs(obj.mySwiper.translate)){
                    obj.year.forEach(function (item,index) {
                        toNum+=item.value;
                        if(toNum*obj.slideTimeWidth<=Math.abs(obj.mySwiper.translate)){
                            obj.yearNum+=1;
                        }
                    });
                }
                obj.year.forEach(function (item,index) {
                     if(index<=obj.yearNum-1){
                         theNum+=item.value;
                     }
                    if(index<=obj.yearNum){
                        nextNum+=item.value;
                    }
                });
                if(obj.isPC){
                    var slideWidth = obj.slideTimeWidth*nextNum-obj.slideTimeTitle;
                }else {
                    var slideWidth = obj.slideTimeWidth*nextNum-obj.slideTimeTitlePhone;
                }

                if(obj.mySwiper.translate<0){
                    if(obj.yearNum>0){
                        for(var j=0;j<obj.yearNum;j++){
                            // $('.time-axises-absolute').eq(j).css({left: '-176px','z-index': 10});
                            if(obj.isPC){
                                $('.time-axises-absolute').eq(j).css({left: '-86px','z-index': 10});
                            }else {
                                $('.time-axises-absolute').eq(j).css({left: '-102px','z-index': 10});
                            }
                        }
                        $('.time-axises-absolute').eq(obj.yearNum).css({left: '0','z-index': 10});
                    }else {
                        $('.time-axises-absolute').eq(0).css({left: '0','z-index': 10});
                    }
                    if(Math.abs(obj.mySwiper.translate)>=slideWidth){
                        var toTrans = slideWidth - Math.abs(obj.mySwiper.translate);
                        $('.time-axises-absolute').eq(obj.yearNum).css({left: toTrans+'px','z-index': 10});
                    }
                    if(obj.slideTimeWidth*nextNum>=Math.abs(obj.mySwiper.translate)&&obj.slideTimeWidth*theNum<=Math.abs(obj.mySwiper.translate)){
                        var size = Math.round(obj.slideTimeWidth*nextNum-Math.abs(obj.mySwiper.translate));
                        var toSize = Math.round(Math.abs(obj.mySwiper.translate)-obj.slideTimeWidth*theNum);
                        var theSize = Math.round(Math.abs(obj.mySwiper.translate)-obj.slideTimeWidth*(theNum+obj.year[obj.yearNum].value-1));
                        if(size<=obj.slideTimeWidth&&toSize<=obj.slideTimeWidth*obj.year[obj.yearNum].value){
                            // $('.swiper-slide').eq(obj.year[obj.yearNum].place+1).find('.time-axises-item').css({'font-size': 38+38/obj.slideTimeWidth*theSize+'px'});
                        }else {
                            var inNum = obj.year[obj.yearNum].place+1;
                            // $('.swiper-slide').eq(inNum-1).find('.time-axises-item').css({'font-size': '78px'});
                            // $('.swiper-slide:gt('+inNum+')').find('.time-axises-item').css({'font-size': '38px'});
                        }
                    }
                }else {
                    $('.time-axises-absolute').eq(0).css({left: '0','z-index': 10});
                    // $('.swiper-slide:gt(0)').find('.time-axises-item').css({'font-size': '38px'});
                }
            },
            'mySwiper.activeIndex': function () {
                this.page = this.mySwiper.activeIndex;
            }
        },
        mounted: function(){
            // this.init();
            this.pcIs();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./fnjinews2021/component/swiper-time.js
// module id = 131
// module chunks = 0